import Auth from "@aws-amplify/auth";

export default {
  setIDToken(context, payload) {
    context.commit("setIDToken", payload);
  },
  setAccessToken(context, payload) {
    context.commit("setAccessToken", payload);
  },
  setUserId(context, payload) {
    context.commit("setUserId", payload);
  },
  setIsAuthenticated({ commit }, isAuthenticated) {
    commit('setIsAuthenticated', isAuthenticated);
  },
  setEmail(context, payload) {
    context.commit("setEmail", payload);
  },
  setSession(context, payload) {
    context.commit("setSession", payload);
  },
  setGivenName(context, payload) {
    context.commit("setGivenName", payload);
  },
  setFamilyName(context, payload) {
    context.commit("setFamilyName", payload);
  },
  setCompanyCode(context, payload) {
    context.commit("setCompanyCode", payload);
  },
  setCompanyName(context, payload) {
    context.commit("setCompanyName", payload);
  },
  async logout(context) {
    try {
      context.commit("setClearAuthData");
      await Auth.signOut();
    } catch (error) {
      console.error("Error during logout:", error);
    }
  },
  async signIn(context) {
    console.log("sign in called");
    await Auth.federatedSignIn({
      customProvider: process.env.VUE_APP_AWS_COGNITO_IDP,
    });
    context.commit("signedIn");
  },
  async currentUserInfo(context) {
    console.log("currentUserInfo in called");
    const currentUser = await Auth.currentUserInfo();
    context.commit("setUsername", currentUser);
  },
  autoLogout(context) {
    context.dispatch("logout");
    context.commit("setAutoLogout");
  },
};
